export default "__VITE_ASSET__u7K$ajvLf3eL0A5ibt$nLA__ 480w, __VITE_ASSET__NMVLWf4DMBUp84Fp5hzlPw__ 768w, __VITE_ASSET__Pfiv8SoUfQMa_7dTVCKlpQ__ 1122w";